export default __webpack_public_path__ + "img/8.1cd01e0c.jpg";